/**
 * Helper used to display the passed time between a date and today. We display in
 * minutes if the date was at most 15 minutes ago, in hours if it was at most 24 hours
 * ago and in days unless.
 * @param  {string} parsedDate
 * @param  {TranslationT} t
 */
export const getCreationDate = (
    parsedDate: string,
    t: TranslationT,
): string => {
    const date = new Date(parsedDate);
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - date.getTime();
    const minutesAgo = Math.floor(timeDifference / (1000 * 60));
    const hoursAgo = Math.floor(timeDifference / (1000 * 60 * 60));
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (minutesAgo < 60) {
        return t('common.timeDiff.minutes', {
            minutes: minutesAgo,
            count: minutesAgo,
        });
    }
    if (hoursAgo < 24) {
        return t('common.timeDiff.hours', {
            hours: hoursAgo,
            count: hoursAgo,
        });
    }

    return t('common.timeDiff.days', {
        days: daysAgo,
        count: daysAgo,
    });
};
